import React, { useEffect, useState } from "react";
import { Megaphone, Plus, Trash2 } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { useToast } from "../hooks/use-toast";
import api from "../api";

function Card({ children, className = "" }) {
  return <div className={`rounded-2xl border border-slate-200 bg-white p-5 shadow-sm md:p-6 ${className}`}>{children}</div>;
}

export default function NotificationsManager() {
  const { toast } = useToast();
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({ title: "", body: "" });
  const load = () => api.get("/announcements").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!form.title.trim()) return;
    await api.post("/admin/announcements", form);
    setForm({ title: "", body: "" });
    toast({ title: "Announcement published" });
    await load();
  };
  const del = async (id) => { await api.delete(`/admin/announcements/${id}`); load(); };

  return (
    <div className="space-y-6">
      <Card>
        <h2 className="text-base font-bold text-slate-900">Publish an announcement</h2>
        <p className="text-sm text-slate-500">Shown to all applicants on their Announcements page.</p>
        <div className="mt-4 space-y-3">
          <div className="space-y-1.5"><Label>Title</Label><Input value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} /></div>
          <div className="space-y-1.5"><Label>Message</Label><Textarea rows={3} value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} /></div>
          <Button onClick={add} className="btn-primary-gradient gap-1.5 border-0 text-white"><Plus className="h-4 w-4" /> Publish</Button>
        </div>
      </Card>
      <div className="space-y-3">
        {rows.map((a) => (
          <Card key={a.id}>
            <div className="flex items-start justify-between gap-3">
              <div className="flex items-start gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-violet-100"><Megaphone className="h-5 w-5 text-violet-600" /></div>
                <div>
                  <div className="font-semibold text-slate-900">{a.title}</div>
                  <div className="text-sm text-slate-500">{a.body}</div>
                  <div className="mt-1 text-[11px] text-slate-400">{a.date}</div>
                </div>
              </div>
              <button onClick={() => del(a.id)} className="rounded-md p-1.5 text-slate-400 hover:bg-rose-50 hover:text-rose-600"><Trash2 className="h-4 w-4" /></button>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
